
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux/brin",
      function () {
        return require("private-next-pages/jeux/brin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux/brin"])
      });
    }
  